import { make } from 'vuex-pathify'

import dottie from 'dottie'
import { api } from '@/api'

/**
 * semantics try align with DDD
 * @see https://www.thenativeweb.io/blog/2017-10-25-09-46-ddd-and-co-part-1-whats-wrong-with-crud/
 * */

// like: initial state
const state = {
  noops: []
}

// like: aggregated state
const getters = {
  ...make.getters(state)
}

// like: fires events
const mutations = {
  listed(state, { noops }) {
    state.noops = noops
  },
  listingFailed(state) {
    state.noops = []
  }
}

// like: commands
const actions = {
  async list({ commit }) {
    try {
      const response = await api.get('/noops')
      const noops = dottie.get(response, 'data.noops', [])
      commit('listed', { noops })
    } catch (e) {
      commit('listingFailed')
    }
  }
}

// like: domain
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
